import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');

  useEffect(() => {
    // Initialize EmailJS with your public key
    // Replace "YOUR_PUBLIC_KEY_HERE" with your actual EmailJS public key
    emailjs.init("YOUR_PUBLIC_KEY_HERE");
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError('');
    
    try {
      // Send email using EmailJS
      const result = await emailjs.send(
        'YOUR_SERVICE_ID', // Replace with your EmailJS service ID
        'YOUR_TEMPLATE_ID', // Replace with your EmailJS template ID
        {
          from_name: formData.name,
          from_email: formData.email,
          message: formData.message,
          to_name: 'Shiaan',
          reply_to: formData.email,
        }
      );

      if (result.status === 200) {
        setSubmitSuccess(true);
        setFormData({ name: '', email: '', message: '' });
        
        // Reset success message after 5 seconds
        setTimeout(() => setSubmitSuccess(false), 5000);
      }
    } catch (error) {
      console.error('Email send failed:', error);
      
      // Fallback: Show success message and log to console for development
      if (process.env.NODE_ENV === 'development') {
        console.log('Form Data:', formData);
        setSubmitSuccess(true);
        setFormData({ name: '', email: '', message: '' });
        setTimeout(() => setSubmitSuccess(false), 5000);
      } else {
        setSubmitError('Failed to send message. Please try again or contact me directly via email.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="contact-content">
          <div className="contact-info">
            <h3>Let's Talk Business</h3>
            <p>
              Ready to turn your wildest tech dreams into slightly less wild reality? 
              I'm here to help, or at least pretend to be helpful while actually being helpful.
            </p>
            
            <div className="contact-details">
              <div className="contact-detail">
                <div className="contact-icon">📧</div>
                <div className="contact-text">
                  <h4>Email</h4>
                  <a href="mailto:dev@shiaan.com" className="contact-link">dev@shiaan.com</a>
                </div>
              </div>
              
              <div className="contact-detail">
                <div className="contact-icon">📱</div>
                <div className="contact-text">
                  <h4>Phone</h4>
                  <a href="tel:+9607779358" className="contact-link">+960 777 9358</a>
                </div>
              </div>
            </div>
            
            <div className="contact-availability">
              <h4>When I'm Actually Available</h4>
              <p>Sunday - Thursday: 9 AM - 6 PM (Maldives Time)</p>
              <p>Weekends: When I'm not debugging my weekend projects</p>
              <p>Response Time: Usually within 24 hours (unless I'm in the zone)</p>
            </div>
          </div>
          
          <div className="contact-form-container">
            <form className="contact-form" onSubmit={handleSubmit}>
              <h3>Send Me a Message</h3>
              
              <div className="form-group">
                <label htmlFor="name">Your Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Who are you, mysterious stranger?"
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Your Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Where should I send my witty replies?"
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Your Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell me about your project, your dreams, or just say hi. I'm not picky."
                  required
                ></textarea>
              </div>
              
              <button 
                type="submit" 
                className="submit-btn" 
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending... (Please Wait)' : 'Send Message (I Dare You)'}
              </button>
              
              {submitSuccess && (
                <div className="submit-success">
                  Message sent! I'll get back to you when I finish my coffee break.
                </div>
              )}
              
              {submitError && (
                <div className="submit-error">
                  {submitError}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact; 